'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MessageService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageService = exports.MessageService = function () {
    function MessageService(winresCloudService) {
        _classCallCheck(this, MessageService);

        this.winresCloudService = winresCloudService;
    }

    _createClass(MessageService, [{
        key: 'getMessage',
        value: function getMessage(code, language) {
            // Messages are cached, so even if this function is called with multiple
            // codes, we'll only make one request to the backend.
            return this.getMessages(language).then(function (messages) {
                return messages[code] || '';
            });
        }
    }, {
        key: 'getMessages',
        value: function getMessages(language) {
            // This can be cached since the messages shouldn't change rapidly.
            var req = this.winresCloudService.get('Messages', { cache: true });
            return req.then(function (response) {
                var messages = response.data;
                return _.mapValues(messages, function (message) {
                    return message[language] || '';
                });
            });
        }
    }, {
        key: 'checkTravelPackage',
        value: function checkTravelPackage(products) {
            // Used to identify cached request.
            var cacheKey = _.map(products, function (p) {
                return p.Product.DestinationInfo.DestinationCode + '|' + p.Product.DestinationInfo.ProductCode + '|' + p.TotalPrice;
            }).join('-');

            return this.winresCloudService.makeAuthenticatedRequest('CheckTravelPackage', {
                'Products': (0, _utils.toTravelPackageProducts)(products)
            }, true, undefined, cacheKey);
        }
    }]);

    return MessageService;
}();

MessageService.$inject = ['winresCloudService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/messageService.js
// module id = 570
// module chunks = 2